import React from 'react'
import Logoar from "./pics/logo.jpeg";
import Share from "../../components/share.js";
import "./jawaan.css" 
import img from "./pics/jaane.png";
const Jaanejaan = () => { 
  return  (
 
    <div className="shortstory-container">
        <img src={Logoar} alt="Logoar" className="logoarr" />
      <div className="blue-bg">
     
      
        
        <header class="entry-header">
		<h4 class="entry-meta"><a href="https://nooffensebut.vercel.app/MovieReviews" target='_blank' data-wpel-link="internal">Movie and Show Reviews</a></h4>
		<h1 class="entry-title">Jaane Jaan</h1>
		<div class="entry-meta">
			<span class="byline">by <span class="author vcard"><a class="url fn n" href="https://nooffensebut.vercel.app/aboutus" target='_blank' data-wpel-link="internal">Harshala</a></span></span><span class="meta-divider"> | </span><span class="posted-on"><a href="https://nooffensebut.vercel.app/content" target='_blank' rel="bookmark" data-wpel-link="internal"><time class="entry-date published" datetime="2018-03-01T07:27:10-05:00">12.10.2023</time><time class="updated" datetime="2018-03-01T11:10:42-05:00"></time></a><span>		</span></span></div>
	</header>
       
 
  <img src={img} alt="Logoar" className="moo" />

        <div className="description1-2">
            <div className="rate">Rating: 3.5</div> <div className="genre">Genre:Crime,Drama,Mystery</div>
            <p>The film is an adaptation of the 2005 Japanese novel The Devotion of Suspect X by Keigo Higashino.</p>
<br/>
<p>It is undoubtedly a fantastic story, no question about that. However, the storytelling in the movie leaves much to be desired. The film kicks off in the picturesque setting of Kalmipong, skillfully portraying the adversities and unwavering determination of a single mother, Maya D'Souza, portrayed impeccably by Kareena. Her character radiates strength and a willingness to go to any lengths to ensure her daughter's safety and well-being.</p>
<br/>
<p>Jaideep's portrayal of Naren Vyas, a character defined by his enigmatic and intense obsession with mathematics, is both bewildering and captivating. Inspector Karan Anand, portrayed by Vijay Verma, while competently executed, falls into the expected mold of a typical policeman role in the movie.</p>
<br/>
<p>Regrettably, the narrative loses its momentum after the promising beginning. It's here that the film falters, failing to maintain the gripping pace and engagement established in its first quarter.</p>
<br/>
<p>Given the remarkable talents of actors like Kareena Kapoor, Jaideep Ahlawa, and Vijay Verma, and the potential of the intriguing storyline, the movie had the ingredients to be truly exceptional. Watching the film, there's a persistent sense of waiting for a significant plot element to drop, yet it never materializes, leaving the viewer with unmet expectations.</p>

           <br/>


    <hr></hr>
</div>



          <Share/>
      </div>
</div> )}

export default Jaanejaan;

 


